import { render, staticRenderFns } from "./sampleDesc.vue?vue&type=template&id=23c832bc&scoped=true"
import script from "./sampleDesc.vue?vue&type=script&lang=js"
export * from "./sampleDesc.vue?vue&type=script&lang=js"
import style0 from "./sampleDesc.vue?vue&type=style&index=0&id=23c832bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c832bc",
  null
  
)

export default component.exports